import React from 'react';
import parse from 'html-react-parser';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonCollapseItem from '../../../common-components/common-collapse-item';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const list1 = [
    {
        title: 'Запустили рекламные компании Facebook, Яндекс.Директ, Google Ads, myTarget',
        subtitle:
            'Запуск РК&nbsp;в&nbsp;Facebook, myTarget, Яндекс.Директ и&nbsp;Google Ads по&nbsp;всем направлениям: бренды (ЭКСАР, РЭЦ, Росэксимбанк), аналитика, экспорт товаров, поиск рынков сбыта, премия &laquo;Экспортер года&raquo;, пособия в&nbsp;период кризиса, мероприятия, образование.',
    },
    {
        title: 'Провели аудит ключевых фраз, составили рекомендации по оптимизации',
        subtitle:
            'Аудит ключевых фраз и&nbsp;внесение правок, в&nbsp;том числе минус-слов, операторов, расширений, перенос фраз в&nbsp;более релевантные группы, удаление дублей, подбор новых ключевых фраз.',
    },
    {
        title: 'Создали и запустили компании на посетителей информационных сайтов',
        subtitle: 'Запуск РК&nbsp;на&nbsp;посетителей информационных сайтов.',
    },
    {
        title: 'Запуск на&nbsp;трафикообразующие ключи',
        subtitle:
            'Запуск на&nbsp;трафикообразующие ключи&nbsp;РК в&nbsp;Контекстно-медийной сети Google.',
    },
    {
        title: 'Провели работу со ставками',
        subtitle:
            'Анализ, корректировка, тестирование автоматических и&nbsp;ручных стратегий назначения ставок.',
    },
    {
        title: 'Поработали с текстами',
        subtitle:
            'Составление более релевантных заголовков, полное заполнение всех частей объявления, составление текстов по&nbsp;принципу&nbsp;4U',
    },
    {
        title: 'Создали кампании в myTarget',
        subtitle: 'Создание кампании на основе контекстного таргетинга в myTarget.',
    },
];

const list2 = [
    {
        title: 'Работу с&nbsp;семантикой для увеличения трафика',
        subtitle:
            'Увеличили количество ключей в&nbsp;1,5 раза за&nbsp;счет проработки ниш и&nbsp;стран. Сделали креативы с&nbsp;их&nbsp;сочетанием, чтобы найти предпринимателей или людей, которые только прощупывают почву для нового бизнеса и&nbsp;задают неявные запросы. Например, с&nbsp;запрос цен на&nbsp;экспорт цветов в&nbsp;Японии, чтобы изучить спрос и&nbsp;провести конкурентный анализ.',
    },
    {
        title: 'Работу со&nbsp;сниппетами',
        subtitle:
            'Раньше в&nbsp;сниппете Российского экспортного центра автоматически отображался только московский адрес головного офиса, хотя представительства компании располагаются в&nbsp;11&nbsp;субъектах по&nbsp;всей стране. Чтобы увеличить трафик, мы&nbsp;расширили сниппет, подключили быстрые ссылки на&nbsp;сайт и&nbsp;адреса для 11&nbsp;субъектов. А&nbsp;также добавили рейтинг и&nbsp;отзывы на&nbsp;картах. ',
    },
    {
        title: 'Точечную оптимизацию самых посещаемых страниц',
        subtitle:
            'Точечно вручную мы&nbsp;оптимизировали заголовки и&nbsp;поправили микроразметку на&nbsp;самых частотных страницах, выявили дополнительный спрос и&nbsp;создали посадочные страницы.',
    },
    {
        title: 'Технический аудит реализацию задач&nbsp;по&nbsp;нему',
        subtitle: `<ul>
                        <li>Проверка корректности индексации сайта в&nbsp;поисковых системах.</li>
                        <li>Анализ конкурентов по&nbsp;семантическому ядру: типы посадочных, тип контента, структура документов, коммерческие факторы. На&nbsp;основе этих данных подготовлены: необходимая структура разделов, ТЗ&nbsp;на&nbsp;контент для посадочных страниц.</li>
                        <li>Поиск дублирующихся страниц в&nbsp;индексе, анализ причин их&nbsp;появления и&nbsp;поиск полных и&nbsp;частичных дубликатов страниц сайта.</li>
                        <li>Проверка на&nbsp;наличие в&nbsp;индексе добавочной фильтрации группы элементов и&nbsp;параметров в&nbsp;URL.</li>
                        <li>Поиск служебных и&nbsp;несуществующих страниц в&nbsp;индексе, рекомендации по&nbsp;их&nbsp;устранению.</li>
                        <li>Проверка склейки дубликатов продвигаемых страниц.</li>
                        <li>Общий анализ структуры поискового трафика.</li>
                        <li>Проверка сайта на&nbsp;ошибки в&nbsp;HTML-коде, рекомендации по&nbsp;исправлению.</li>
                        <li>Корректность ответов сервера основных страниц сайта.</li>
                        <li>Выявление не&nbsp;индексируемого контента и&nbsp;факторов, которые на&nbsp;это влияют.</li>
                        <li>Проверка на&nbsp;возможность создания неограниченного количества дублей целевых страниц. Анализ ссылочной структуры сайта, выявление динамических дублей, снижающих скорость индексации.</li>
                        <li>Выявление битых ссылок и&nbsp;не&nbsp;корректных редиректов, в&nbsp;том числе множественных.</li>
                        <li>Проверка корректности обработки пагинатора.</li>
                        <li>Анализ распределения статического веса по&nbsp;страницам сайта.</li>
                        <li>Анализ скорости загрузки различных типов страниц сайта.</li>
                        <li>Проверка, создание и&nbsp;обновление файлов robots.txt и&nbsp;sitemap.xml.</li>
                        <li>Дополнительные рекомендации: разметить хлебные крошки микроразметкой аналогично другим страницам сайта, а&nbsp;для раздела новостей &laquo;Экспортер года&raquo;&nbsp;&mdash; сформировать шаблонные метатеги.</li>
                    </ul>`,
    },
];

const Process = () => {
    return (
        <ScrollAnimation delay={0} animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper caseName="rec-process" bigPaddings={true} isMargin={false}>
                <div className="rec-process__wrapper">
                    <div className="rec-process__container">
                        <div className="rec-process__img-container">
                            <CommonTitle>Процесс</CommonTitle>
                            <CommonUsualText className="rec-process__subtitle">
                                Чтобы решить поставленные клиентом задачи, нам нужно было выполнить
                                работы по&nbsp;контекстной рекламе и&nbsp;SEO
                            </CommonUsualText>
                            <img
                                className="rec-process__img"
                                src="/images/svg/rec/rec-process__img1.svg"
                                alt=""
                                loading="lazy"
                            />
                        </div>
                        <div className="rec-process__info">
                            <CommonSmallTitle>В контекстной рекламе мы</CommonSmallTitle>
                            <div className="rec-process__list">
                                {list1.map(({ title, subtitle }, index) => (
                                    <CommonCollapseItem
                                        key={index}
                                        white={true}
                                        index={++index}
                                        triggerText={parse(title)}
                                        content={parse(subtitle)}
                                        numberColor={'#7927E0'}
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: subtitle }} />
                                    </CommonCollapseItem>
                                ))}

                                <CommonCollapseItem
                                    white={true}
                                    index={8}
                                    triggerText={'Создали таргетированные рекламные кампании'}
                                    content={parse(
                                        'Создание ретаргетинговых рекламных кампаний для контекстной и&nbsp;таргетированной рекламы по&nbsp;условиям совершения микроконверсий.'
                                    )}
                                    numberColor={'#7927E0'}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="rec-process__container">
                        <div className="rec-process__img-container">
                            <img
                                className="rec-process__img"
                                src="/images/svg/rec/rec-process__img2.svg"
                                alt=""
                                loading="lazy"
                            />
                        </div>
                        <div className="rec-process__info">
                            <CommonSmallTitle>В SEO-продвижении мы провели</CommonSmallTitle>
                            <div className="rec-process__list">
                                {list2.map(({ title, subtitle }, index) => (
                                    <CommonCollapseItem
                                        key={index}
                                        white={true}
                                        index={++index}
                                        triggerText={parse(title)}
                                        content={parse(subtitle)}
                                        numberColor={'#7927E0'}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Process;
